import { create } from 'zustand';
import i18n from 'i18n';
import { ResourceApi, RestApiError, StatusCodeEnum } from '@shared/api';
import type { BaseReturn } from '@shared/types';

interface useTCStore {
  loading: boolean;
  data: string | null;
  error?: string | null;
  get: (productName: string) => Promise<BaseReturn<string | null>>;
  clear: () => void;
}

export const useTCStore = create<useTCStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  get: async (productName: string) => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await ResourceApi.getTC(productName);
      const text = await result.text();
      set({ loading: false, data: text ?? [] });
      return { loading: false, data: text ?? [] };
    } catch (err) {
      const restError = err as RestApiError;

      let errorMessage = 'Something went wrong, try again';
      switch (restError?.status) {
        case StatusCodeEnum.API_ERROR_UNAUTHORIZED:
          errorMessage = 'Your session was expired, sign in again';
          break;
      }

      const error = i18n.t(`errors.api.${errorMessage}`, errorMessage);
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
